import {useEffect, useState} from "react";

interface IProps {
    documentId?: string;
}


export const useFetchVendorInvoice = ({documentId}: IProps) => {
    const [isDocumentLoading, setIsDocumentLoading] = useState(false);

    const fetchDocument = async () => {
        try {
            setIsDocumentLoading(true);
        } catch (e) {
            console.log(e);
        } finally {
            setIsDocumentLoading(false);
        }
    }

    useEffect(() => {
        if (documentId) {
            setIsDocumentLoading(true);
            fetchDocument();
        }
    }, [documentId]);

    return {
        isDocumentLoading,
    }
}